import { Button, Col, message, Row, Select } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { dashboard as dashboardCall } from "../../actions/dashboard/dashboard";
import CategoriesIcon from "../../assets/icons/Categories@3x.png";
import users from "../../assets/icons/users_controls@3x.png";
import { amountFormat, getBoolVal, getWidth, hasAccess } from "../../utils";
import "./dashboard.css";
import PendingAvancesCard from "./PendingAdvancesCard";
import PendingReportsCard from "./PendingReportsCard";
import PendingCard from "./PendingTripsCard";
import TopSec from "./TopSec";
import BaseCurrency from "../Common/BaseCurrency";
import { remind_card_activation } from "../../actions/cards/cards";

const Dashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const dashboard = useSelector((state) => state?.dashboard?.dashboard);
  const remindCardActivation = useSelector(
    (state) => state?.cards?.remind_card_activation
  );
  useEffect(() => {
    if (getBoolVal(sessionStorage.getItem("is_Admin"))) {
      dispatch(dashboardCall());
      dispatch(dashboardCall({ dashboard: "second" }));
      dispatch(dashboardCall({ dashboard: "third" }));
      dispatch(dashboardCall({ dashboard: "fourth" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { data = {} } = remindCardActivation;
    if (data?.status) {
      message.success(<span className="messageText">{"Reminder Sent."}</span>);
    }

    if (data?.status === false) {
      message.success(<span className="messageText">{"Reminder Sent."}</span>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remindCardActivation]);

  const colors = {
    meal: "#00B200",
    fuel: "#0F33AC",
    gift: "#F759F1",
    expense: "#10A59A",
    reimbursement: "#AAA31B",
    transit: "#10A59A",
    offline: "#33333380",
    0: "#00B200",
    1: "#0F33AC",
    2: "#F759F1",
    3: "#10A59A",
    4: "#10A59A",
  };

  return (
    <div className="dashboard mb3">
      <div className="head">
        <h2>
          Dashboard
          <span>Overview of Account</span>
        </h2>
        {/* <span className="active-text">Getting Started</span> */}
      </div>
      <Row className="mt1">
        <Col span={22}>
          {hasAccess("users_and_controls", "write") && (
            <Button
              type="default"
              className="dashButtons"
              onClick={() => {
                history.push("/setting/users", {
                  openAddNew: true,
                });
              }}
            >
              <img src={CategoriesIcon} alt={"logo"} className="menu-logo" />
              Invite / Add Employee
            </Button>
          )}
          {hasAccess("transfers", "write") && (
            <Button
              type="default"
              className="dashButtons"
              onClick={() => {
                history.push("/transfers/quick-transfers");
              }}
            >
              <img src={CategoriesIcon} alt={"logo"} className="menu-logo" />
              Initiate Quick Load
            </Button>
          )}
          {hasAccess("expense_reports", "read") && (
            <Button
              type="default"
              className="dashButtons"
              onClick={() => {
                history.push("/reports");
              }}
            >
              <img src={CategoriesIcon} alt={"logo"} className="menu-logo" />
              View Reports and Summary
            </Button>
          )}
          {hasAccess("organisation_settings", "read") && (
            <Button
              type="default"
              className="dashButtons"
              onClick={() => {
                history.push("/setting");
              }}
            >
              <img src={CategoriesIcon} alt={"logo"} className="menu-logo" />
              Configure Settings
            </Button>
          )}
        </Col>
      </Row>
      <TopSec dashboard={dashboard?.first?.response?.dashboard} />
      <div className="d-flex gap1">
        <PendingCard dashboard={dashboard?.second?.response?.dashboard} />
        <PendingReportsCard
          dashboard={dashboard?.second?.response?.dashboard}
        />
        <PendingAvancesCard
          dashboard={dashboard?.second?.response?.dashboard}
        />
      </div>
      <div className="mt1 bottom-sec">
        <div className="d-flex gap1">
          <div className="corporate-card card p1 w100">
            <h2 className="mb1">Corporate cards</h2>
            <div className="d-flex gap1">
              <div>
                <div className="top">
                  <span>Active Cards</span>
                  <span>
                    {dashboard?.third?.response?.dashboard?.active_card}
                  </span>
                </div>
                <div className="bottom">
                  <span>Total Available Balance</span>
                  <span>
                    <BaseCurrency />{" "}
                    {amountFormat(
                      dashboard?.third?.response?.dashboard
                        ?.total_available_balance
                    )}
                  </span>
                </div>
              </div>
              <div>
                <div className="top">
                  <span>Pending Activation</span>
                  <span>
                    {dashboard?.third?.response?.dashboard?.pending_activation}
                  </span>
                </div>
                <div className="bottom">
                  <span>Send Reminder Alert</span>
                  <span
                    onClick={() => {
                      dispatch(remind_card_activation());
                    }}
                    className={`customize fs-sm ${
                      dashboard?.third?.response?.dashboard
                        ?.pending_activation > 0
                        ? "cursor"
                        : "disabled"
                    }`}
                  >
                    Remind
                  </span>
                </div>
              </div>
              <div>
                <div className="top">
                  <span>Un-Assigned Cards</span>
                  <span>
                    {dashboard?.third?.response?.dashboard?.unassigned_cards}
                  </span>
                </div>
                <div className="bottom">
                  <span>Assign it to Users</span>
                  <span
                    className="customize fs-sm"
                    onClick={() => {
                      history.push("/card-inventory");
                    }}
                  >
                    Assign now
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="card p1 w100">
            <h2 className="mb1">Top spend by Cost Center</h2>
            {dashboard?.fourth?.response?.dashboard?.spend_by_cost_center &&
            Object.keys(
              dashboard?.fourth?.response?.dashboard?.spend_by_cost_center
            )?.length > 0 ? (
              Object.keys(
                dashboard?.fourth?.response?.dashboard?.spend_by_cost_center
              ).map((ele, i) => (
                <div className="wallet-row">
                  <p>{ele}</p>
                  <div className="flex-between">
                    <div
                      className="w75 mr1"
                      style={{
                        background: colors[i] + " 0% 0% no-repeat padding-box",
                        borderRadius: "4px",
                        height: 5,
                        width: `${getWidth(
                          Object.values(
                            dashboard?.fourth?.response?.dashboard
                              ?.spend_by_cost_center
                          ),
                          dashboard?.fourth?.response?.dashboard
                            ?.spend_by_cost_center[ele]
                        )}%`,
                      }}
                    ></div>
                    <div>
                      <BaseCurrency />
                      {amountFormat(
                        dashboard?.fourth?.response?.dashboard
                          ?.spend_by_cost_center[ele]
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-data">
                <span>No cost centers</span>
              </div>
            )}
          </div>
          <div className="card p1 w100">
            <h2 className="mb1">Top Spend by Project</h2>
            {dashboard?.fourth?.response?.dashboard?.spend_by_project &&
            Object.keys(
              dashboard?.fourth?.response?.dashboard?.spend_by_project
            )?.length > 0 ? (
              Object.keys(
                dashboard?.fourth?.response?.dashboard?.spend_by_project
              ).map((ele, i) => (
                <div className="wallet-row">
                  <p>{ele}</p>
                  <div className="flex-between">
                    <div
                      className="w75 mr1"
                      style={{
                        background: colors[i] + " 0% 0% no-repeat padding-box",
                        borderRadius: "4px",
                        height: 5,
                        width: `${getWidth(
                          Object.values(
                            dashboard?.fourth?.response?.dashboard
                              ?.spend_by_project
                          ),
                          dashboard?.fourth?.response?.dashboard
                            ?.spend_by_project[ele]
                        )}%`,
                      }}
                    ></div>
                    <div>
                      <BaseCurrency />
                      {amountFormat(
                        dashboard?.fourth?.response?.dashboard
                          ?.spend_by_project[ele]
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-data">
                <span>No Spends</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
